import React from "react";
import styles from './BouncingDotsLoader.module.css'
import answerstyles from '../Answer/Answer.module.css'
import {Stack} from "@fluentui/react";

export const BouncingDotsLoader = () => {
    return (
        <Stack className={answerstyles.answerContainer} tabIndex={0}>
            <div className={styles.wave}>
                <span className={styles.dot}></span>
                <span className={styles.dot}></span>
                <span className={styles.dot}></span>
            </div>
        </Stack>
    );
};
